import {
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";
import EmailTemplates from "../EmailTemplates/EmailTemplates";
import EmailLogs from "../EmailLogs/EmailLogs";

function EmailSettings(props) {
  const [tab, setTab] = useState(0);

  useEffect(() => {
    props.setTitle("Email Settings");
  }, []); // eslint-disable-line

  if (props.user.accessLevel > 1) return null;

  return (
    <Card sx={{ p: 1.5 }}>
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h6">Email Settings</Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5, mb: 2 }}>
          Manage templates and track delivery logs for your organization.
        </Typography>

        <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} sx={{ mb: 2 }}>
          <Tab label="Email Templates" />
          <Tab label="Email Logs" />
        </Tabs>

        <Box hidden={tab !== 0}>
          <EmailTemplates organization={props.organization} />
        </Box>
        <Box hidden={tab !== 1}>
          <EmailLogs organization={props.organization} />
        </Box>
      </CardContent>
    </Card>
  );
}

export default EmailSettings;
